<script lang="ts">
  import { CheckCircle, ShieldCheck } from "svelte-hero-icons";

  const props = {
    class: "flex items-center flex-row",
  };
</script>

<ul
  class="space-y-2 bg-green-50 border border-green-500 text-green-500 rounded-md px-4 py-1 ">
  <li {...props}>
    <ShieldCheck class="text-green-500 mr-3 w-5 h-5" />
    <span class="flex-1">Secured Connection</span>
  </li>
  <li {...props}>
    <ShieldCheck class="text-green-500 mr-3 w-5 h-5" />
    <span class="flex-1">Only connected account id saved</span>
  </li>
  <li {...props}>
    <ShieldCheck class="text-green-500 mr-3 w-5 h-5" />
    <span class="flex-1">No balances saved</span>
  </li>
  <li {...props}>
    <ShieldCheck class="text-green-500 mr-3 w-5 h-5" />
    <span class="flex-1">No transactions saved</span>
  </li>
  <li {...props}>
    <CheckCircle class="text-green-500 mr-3 w-5 h-5" />
    <span class="flex-1">Synced up to 4 times a day</span>
  </li>
</ul>
